<template>
  <div class="container">
    <van-nav-bar :title="$t('withdraw.withdraw')">
      <template #left>
        <van-icon name="arrow-left" color="#fff" size="20"  @click="back()"></van-icon>
      </template>
      <template #right>
        <div class="record" @click="goRecord">{{ $t('withdraw.record') }}</div>
      </template>
    </van-nav-bar>
    <div class="header">
      <div class="ipu">
        <div class="title">{{ $t("withdraw.withdraw_balance") }}</div>
        <div class="input_wrap">
          <van-field v-model="withdraw_money" :placeholder="$t('withdraw.placeholder')" type="number" />
        </div>
        <div class="balance">{{ $t("withdraw.amount_balance") }}: <span>{{ changeMoney(userInfo.money) }}</span></div>
      </div>
      
      <div class="ipu">
        <div v-if="accountRows.length" class="account-card">
          <div class="account-row" v-for="row in accountRows" :key="row.key">
            <div class="account-label">{{ row.title }}</div>
            <div class="account-value">{{ row.value }}</div>
          </div>
        </div>
        <div v-else-if="!configLoading" class="empty-account">
          <div class="empty-tip">{{ $t("withdraw.account_empty") }}</div>
          <div class="bind-btn" @click="goBind">{{ $t("withdraw.go_bind") }}</div>
        </div>

        <template v-if="accountRows.length">
          <div class="text" style="margin-top: 5%;">{{ $t("withdraw.send_password") }}</div>
          <div class="input_wrap input_wrap2">
            <van-field v-model="pay_password" :placeholder="$t('withdraw.pay_placeholder')" type="password" clearable/>
          </div>
        </template>
      </div>

      <div v-if="accountRows.length" class="button" @click="submit">{{ $t("withdraw.submit") }}</div>
    </div>
  </div>
</template>

<script>
import { changeMoney } from '@/common/function';
import {
  describeWithdrawInfo,
  parseWithdrawInfo,
  resolveWithdrawConfig,
  resolveWithdrawFields
} from '@/common/withdrawForm';

export default {
  data() {
    return {
      userInfo: {},
      withdraw_money: null,
      pay_password: null,
      withdrawInfo: [],
      accountInfo: {},
      configLoading: true,
      submitting: false
    };
  },
  computed: {
    accountRows() {
      return describeWithdrawInfo(this.withdrawInfo, this.accountInfo);
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getWithdrawConfig();
    }
     
  },
  methods: {
    back(){
      return window.history.back();
    },
    goRecord() {
      this.$router.push("WithdrawRecord");
    },
    goBind() {
      this.$router.push('/BindCard');
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
            this.userInfo = res.data;
            if(this.userInfo.status !== 1){
              this.$toast(this.$t("video.account_out"));
              localStorage.clear()
              this.$router.push({path:'/Login'})
            }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getWithdrawConfig(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_config'
      }).then(res=>{
        this.configLoading = false;
        if(res && res.code === 200){
          const config = resolveWithdrawConfig(res);
          this.withdrawInfo = resolveWithdrawFields(config);
          this.accountInfo = parseWithdrawInfo(config.account && config.account.withdraw_info);
        }else if(res && res.code ===401){
          this.$toast(res.msg);
        }
      }).catch(()=>{
        this.configLoading = false;
      })
    },
    submit() {
      if(this.submitting){
        return false;
      }
      const money = Number(this.withdraw_money);
      if(!this.withdraw_money || isNaN(money) || money <= 0){
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }
      if(!this.pay_password){
        this.$toast(this.$t("withdraw.pay_password"));
        return false;
      }
      if(!this.accountRows.length){
        this.$toast(this.$t("withdraw.account_empty"));
        return false;
      }
      this.submitting = true;
      this.$http({
        method: 'post',
        data: {
          money: this.withdraw_money,
          pay_password: this.pay_password,
          withdraw_info: JSON.stringify(this.accountInfo)
        },
        url: 'user_set_withdraw'
      }).then(res=>{
        this.submitting = false;
        if(!res || res.code === undefined){
          this.$toast(this.$t("withdraw.config_error"));
          return;
        }
        this.$toast(res.msg);
        if(res.code === 200){
          this.getUserInfo();
          this.getWithdrawConfig();
          this.pay_password = null
          this.withdraw_money = null
        }
      }).catch(()=>{
        this.submitting = false;
      })
    },
  }
};
</script>

<style lang='less' scoped>
.container{
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
}

.van-nav-bar {
  background: linear-gradient(120deg, #f3a3c4 0%, #c3a6f0 55%, #ffb894 100%);
  height: 2.88rem;
  position: relative !important;

  /deep/ .van-nav-bar__title{
    color: #fff;
    font-size: 1rem;
  }
  /deep/ .van-nav-bar__left{
    padding: 0 1rem;
  }
  .record{
    font-size: 0.88rem;
    color: #fff;
  }
}


.ipu{
  width: 95%;
  margin: 0.75rem auto 0;
  // height: 8rem;
  background: #fff;
  border-radius: 0.5rem;
  padding: 1rem 5%;
  box-shadow:#ccc 0.00rem 0.00rem 0.22rem;
  .title{
    font-size: .9rem;
    color: #442b89;
  }
  .input_wrap{
    background-color: inherit !important;
    background: #fff;
    border-radius: 0.9rem;
    border: 1px solid #f0e2f2;
    height: 3.00rem;
    margin-top: 4.5%;
    margin-bottom: 4.5%;
    display: flex;
    align-items: center;
    .hs{
      display: flex;
      align-items: center;
      width: 20%;
      justify-content: flex-start;
      .line{
        width: .0625rem;
        background-color: #999;
        height: 1rem;
        margin-left: 10%;
        margin-right: 10%;
      }
      .label{
        color: #442b89;
        font-size: 1rem;
      }
    }
  }

  
  
  .van-field{
    background-color: transparent;
    padding: 0 1.25rem;
    color: #4a3a5c;
    &::-webkit-input-placeholder {
      color: #323233;
    }
    font-size: 0.88rem;
    display: flex;
    align-items: center;
    border-bottom: 0 !important;
    border: none;
    height: 1.50rem;
    &::after{
      display: none;
    }
    /deep/ .van-field__control{
      color: #323233;
      background-color: transparent;
      font-size: .88rem;
    }

    /deep/ .van-field__body{
      height: 1.50rem;
    }
    
  }
  .balance{
    margin-top: 5%;
    color: #3a1a84;
    font-size: .9rem;
    span{
      color: #d53dde;
    }
  }
  
  .input_wrap2{
    .van-field{
      width: 100%;
    }
  }

  .label{
    font-size: 1rem;
    margin-top: 5%;
    padding-bottom: 5%;
    color: #442b89;
  }
  .text{
    color: #442b89;
  }
  .account-card{
    margin-top: 1%;
  }
  .account-row{
    margin-top: 4.5%;
  }
  .account-label{
    color: #4a3a5c;
    font-size: 0.88rem;
  }
  .account-value{
    margin-top: 3%;
    padding: 0 1.25rem;
    min-height: 3rem;
    display: flex;
    align-items: center;
    border: 1px solid #f0e2f2;
    border-radius: 0.9rem;
    background: #fbfbfc;
    color: #4a3a5c;
    font-size: 0.88rem;
    word-break: break-all;
  }
  .empty-account{
    padding: 1rem 0;
    text-align: center;
  }
  .bind-btn{
    display: inline-block;
    margin-top: 0.75rem;
    padding: 0.55rem 1.4rem;
    border-radius: 0.9rem;
    color: #fff;
    font-size: 0.88rem;
    background: linear-gradient(120deg, #f7a1c0 0%, #c3a3f2 55%, #ffbe9c 100%);
  }
  .empty-tip{
    margin-top: 3%;
    font-size: 0.88rem;
    color: #969799;
  }
  .line{
    border-bottom: 0.06rem solid #eee;
  }
}

.button{
  width: 95%;
  margin: 10% auto;
  background: linear-gradient(120deg, #f7a1c0 0%, #c3a3f2 55%, #ffbe9c 100%);
  border-radius: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding: 1.4rem 0;
}

</style>
